// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3xSaR","header":"PatientQuestionnaire_header__2-xZV","info":"PatientQuestionnaire_info__2-RtR"};